<template>
    <section>
        <div class="col-sm-12 ">
            <div class="row justify-content-center">
                <div class="col-md-4">
                    <h3 class="mb-4">{{ __('message_interface.step4.your_msg') }}</h3>
                    <PhoneComponent v-if="message.type === 'sms'"
                                    :message="message.messageToSend"
                                    style="margin:0" />
                </div>
                <div class="col-md-4">

                    <div class="mt-1">
                        <h3 class="mb-4"> {{ __('message_interface.tabs.choose_recipient') }}</h3>
                        <div class="custom-radio-primary form-check ">
                            <input id="all_registrants"
                                   class="form-check-input"
                                   type="radio"
                                   name="recipientSelection"
                                   v-model="message.recipientSelection"
                                   value="all_registrants">
                            <label class="font-weight-normal"
                                   for="all_registrants">
                                <p class="mb-0 ml-2 "
                                   style=" font-size: 15px;">
                                    {{ __('message_interface.options.all_registrants') }}
                                </p>

                            </label>
                        </div>
                        <div class="custom-radio-primary form-check pt-3">
                            <input id="all_recipients"
                                   class="form-check-input"
                                   type="radio"
                                   name="recipientSelection"
                                   v-model="message.recipientSelection"
                                   value="all_recipients">
                            <label class="font-weight-normal"
                                   for="all_recipients">
                                <p class="mb-0 ml-2 "
                                   style=" font-size: 15px;">
                                    {{ __('message_interface.options.all_recipients') }}
                                </p>

                            </label>
                        </div>
                        <div class="custom-radio-primary form-check pt-3">
                            <input id="recipient"
                                   class="form-check-input"
                                   type="radio"
                                   name="recipientSelection"
                                   v-model="message.recipientSelection"
                                   value="specific_receiver">
                            <label class="font-weight-normal"
                                   for="recipient">
                                <p class="mb-0 ml-2 "
                                   style=" font-size: 15px;">
                                    {{ __('message_interface.options.specific_person') }}
                                </p>
                            </label>
                        </div>

                        <Multiselect :placeholder="__('message_interface.step4.type_cutomer_number')"
                                     label="first_name"
                                     :custom-label="clientCustomLabel"
                                     track-by="first_name"
                                     :options="clients"
                                     class="pt-2"
                                     v-if="message.recipientSelection === 'specific_receiver'"
                                     ref="getclients"
                                     v-model="message.selectedClient"
                                     :selectLabel="__('message_interface.step4.multiselect.placeholder')">
                            <template #noResult>
                                {{ __('message_interface.step4.no_result') }}
                                <a @click="addNewClientToSend"
                                   class="text-underline">
                                    {{ __('message_interface.step4.add_new_contact') }}
                                </a>
                            </template>
                        </Multiselect>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <button type="button "
                    :disabled="message.loading"
                    @click="$emit('prev-tab')"
                    class="btn btn-primary ">
                {{ __('message_interface.btns.prev') }}
            </button>
            <button class="btn btn-primary float-right"
                    @click="submitSendMessage"
                    :disabled="submitBtnIsDisabled">
                <i v-if="message.loading"
                   class="fa-regular fa-spinner fa-spin-pulse fa-sm mr-2"></i>
                <span>{{ __('message_interface.btns.submit') }}</span>

            </button>
        </div>
        <div class="clearfix"></div>
    </section>
</template>
<script>
import PhoneComponent from "../../messages/ContactCustomerSteps/PhoneComponent.vue";
import Multiselect from 'vue-multiselect'
export default {
    name: 'ChooseRecipients',
    components: {
        Multiselect,
        PhoneComponent,
    },
    props: ['message', 'clients'],
    methods: {
        submitSendMessage() {
            this.$emit('submitSendMessage', this.message);
        },
        clientCustomLabel({ first_name, last_name, dealership, phone, organisation_name }) {
            if (this.message.type === "sms") {
                if (!dealership) {
                    return `${first_name} ${last_name} | ${organisation_name} | ${phone} `;
                }
                return `${first_name} ${last_name} | ${dealership?.long_name} | ${phone} `;
            }
        },
    },
    computed: {
        submitBtnIsDisabled() {
            const { recipientSelection, selectedClient, loading } = this.message;
            return loading || recipientSelection === '' || (recipientSelection === 'specific_receiver' && !selectedClient);
        }
    }

}
</script>
